import React from 'react'
import styled from 'styled-components'
import theme from './theme.js'
import {Icon} from './icon-inline.js'

const IconArticle = ({
  className
}) => {
  const props = {
    className 
  }

  return (
    <Container {...props}>
      <LineTop/>
      <LineMid/>
      <LineBottom/>
      <LineRight/>
      <Fold/>
      <Crease/>
    </Container>
  )
}

const Container = styled(Icon)`
  border: 2px solid ${theme.color.grey.darkest};
  border-width: 0 0 2px 2px;
  opacity: .5;

  &:before {
    content: '';
    width: 101%;
    height: 100%; 
    position: absolute;
    top: 0      ;
    left: 0;
    background: rgba(0,0,0,.1);
    clip-path: polygon(55% 0%, 101% 38%, 100% 100%, 0 100%, 0 0);
    z-index; 0;
  }
`

const Line = styled.div`
  width: 65%;
  height: 2px;
  background: ${theme.color.grey.darkest};
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
`

const LineTop = styled.div`
  top: 0px;
  left: -1px;
  height: 2px;
  width: 74%;
  background: ${theme.color.grey.darkest};
  transform: none;
  right: -1px;
  bottom: -1px;
  position: absolute;
`

const LineMid = styled(Line)`
  top: 58%;
`

const LineBottom = styled(Line)`
  top: 78%;
`

const LineRight = styled.div`
  height: 75%;
  width: 2px;
  background: ${theme.color.grey.darkest};
  transform: none;
  right: -1px;
  bottom: -1px;
  position: absolute;
`

const Fold = styled.div`
  height: 43%;
  width: 57%;
  border: 2px solid ${theme.color.grey.darkest};
  border-width: 0 0 2px 2px;
  transform: none;
  right: -1px;
  top: 0px;
  position: absolute;
`

const Crease = styled.div`
  height: 35%;
  width: 2px;
  background: ${theme.color.grey.darkest};
  transform: rotate(-46deg);
  right: 2px;
  top: 0px;
  position: absolute;
`

export default IconArticle